import * as yup from 'yup';
import { i18n } from '@lt/localization';

export const validatePhoneNumber = (
  value?: string,
  phoneMask?: string,
  countryCode?: string,
): boolean => {
  if (!value || !phoneMask) return false;

  const digitsCount = (phoneMask.match(/\./g) || []).length;

  const cleanValue = value.replace(/\D/g, ''); // Удаляем нецифры

  if (countryCode === 'id') {
    // Для Индонезии допускаем 9–11 цифр + 2 цифры кода страны
    return cleanValue.length >= 11 && cleanValue.length <= 13;
  }
  return cleanValue.length === digitsCount;
};

export const createPhoneValidator = (
  phoneMask?: string,
  countryCode?: string,
) =>
  yup
    .string()
    .test(
      'phone-length',
      i18n.t('checkout.registrationForm.phone.inputError'),
      (value) => validatePhoneNumber(value, phoneMask, countryCode),
    )
    .required(i18n.t('checkout.registrationForm.phone.required'));
